import { Col, Row, Container } from 'reactstrap'
import s from './Reports.scss'
import { Menu } from './Menu'
import { Routes, Route, useLocation } from 'react-router-dom'
import { PipelineByStage } from './PipelineByStage'
import { PipelineByLocation } from './PipelineByLocation'
import { PipelineByClient } from './PipelineByClient'
import { PipelineByUser } from './PipelineByUser'
import { OpportunitiesByInternalTeamRole } from './OpportunitiesByInternalTeamRole'
import { OpportunityBySource } from './OpportunityBySource'
import { OpportunityByBidSubmissionDate } from './OpportunityByBidSubmissionDate'
import { OpportunityByBidSubmissionStatus } from './OpportunityByBidSubmissionStatus'
import { OpportunityByBidDueDate } from './OpportunityByBidDueDate'
import { OpportunityByFollowUpDate } from './OpportunityByFollowUpDate'
import { OpportunityByWonDate } from './OpportunityByWonDate'
import { OpportunityByLostDate } from './OpportunityByLostDate'
import { SalesAndForecast } from './SalesAndForecast'
import { OpportunitiesInForecast } from './OpportunitiesInForecast'
import { AnualOpportunitiesSold } from './AnualOpportunitiesSold'
import { MarginAnalysis } from './MarginAnalysis'
import { OpportunityByContractType } from './OpportunityByContractType'
import { OpportunityByProjectType } from './OpportunityByProjectType'
import { OpportunityByWorkType } from './OpportunityByWorkType'
import { OpportunitiesByQuoteNumber } from './OpportunitiesByQuoteNumber'
import { OpportunitiesByProjectNumber } from './OpportunitiesByProjectNumber'
import { OpportunityByGeoArea } from './OpportunityByGeoArea'
import { OpportunityByCategory } from './OpportunityByCategory'
import { OpportunityByScope } from './OpportunityByScope'
import { OpportunityByPriority } from './OpportunityByPriority'
import { AnualSubmittedBids } from './AnualSubmittedBids'
import { OpportunityByClientBidStage } from './OpportunityByClientBidStage'
import { OpportunityBySize } from './OpportunityBySize'
import { OpportunityByReasonForNotWinning } from './OpportunityByReasonForNotWinning'
import { OpportunityByReasonForNotBidding } from './OpportunityByReasonForNotBidding'
import { OpportunityByPublicPrivate } from './OpportunityByPublicPrivate'
import { OpportunityByHealth } from './OpportunityByHealth'
import { OpportunityByCreationDate } from './OpportunityByCreationDate'
import { OpportunityByStartEndDate } from './OpportunityByStartEndDate'
import { PageTitle } from 'components/common/PageTitle'

const Reports = () => {
  const location = useLocation()
  const activeReport = location.pathname.split('/')[3] || 'sales-and-forecast'
  const activeCategory = location.pathname.split('/')[2] || 'sales'

  return (
    <>
      <PageTitle view="Reports" />
      <Container className={s.container}>
        <Row>
          <Col lg="2">
            <Menu page={activeReport} category={activeCategory} withSearch />
          </Col>
          <Col lg="10">
            <Routes>
              <Route index element={<SalesAndForecast />} />
              <Route path="sales/sales-and-forecast" element={<SalesAndForecast />} />
              <Route path="sales/opportunity-bid-due-date" element={<OpportunityByBidDueDate />} />
              <Route
                path="sales/opportunity-bid-submission-date"
                element={<OpportunityByBidSubmissionDate />}
              />
              <Route
                path="sales/opportunity-creation-date"
                element={<OpportunityByCreationDate />}
              />
              <Route
                path="sales/opportunity-bid-submission-status"
                element={<OpportunityByBidSubmissionStatus />}
              />
              <Route
                path="sales/opportunity-follow-up-date"
                element={<OpportunityByFollowUpDate />}
              />
              <Route path="sales/opportunity-won-date" element={<OpportunityByWonDate />} />
              <Route path="sales/opportunity-lost-date" element={<OpportunityByLostDate />} />
              <Route path="sales/opportunity-source" element={<OpportunityBySource />} />
              <Route path="sales/opportunity-scope" element={<OpportunityByScope />} />
              <Route
                path="sales/opportunity-reason-for-not-winning"
                element={<OpportunityByReasonForNotWinning />}
              />
              <Route
                path="sales/opportunity-reason-for-not-bidding"
                element={<OpportunityByReasonForNotBidding />}
              />
              <Route
                path="sales/opportunity-client-bid-stage"
                element={<OpportunityByClientBidStage />}
              />
              <Route path="sales/opportunity-priority" element={<OpportunityByPriority />} />
              <Route path="sales/opportunity-size" element={<OpportunityBySize />} />
              <Route path="pipeline/pipeline-by-stage" element={<PipelineByStage />} />
              <Route path="pipeline/pipeline-by-location" element={<PipelineByLocation />} />
              <Route path="pipeline/pipeline-by-client" element={<PipelineByClient />} />
              <Route path="team/pipeline-by-user" element={<PipelineByUser />} />
              <Route
                path="sales/opportunities-by-internal-team-role"
                element={<OpportunitiesByInternalTeamRole />}
              />
              <Route path="sales/opportunities-in-forecast" element={<OpportunitiesInForecast />} />
              <Route path="sales/anual-opportunities-sold" element={<AnualOpportunitiesSold />} />
              <Route path="sales/margin-analysis" element={<MarginAnalysis />} />
              <Route path="sales/opportunity-by-category" element={<OpportunityByCategory />} />
              <Route path="sales/opportunity-by-health" element={<OpportunityByHealth />} />
              <Route
                path="sales/opportunity-by-visibility"
                element={<OpportunityByPublicPrivate />}
              />
              <Route
                path="sales/opportunity-by-contract-type"
                element={<OpportunityByContractType />}
              />
              <Route
                path="sales/opportunity-by-project-type"
                element={<OpportunityByProjectType />}
              />
              <Route path="sales/opportunity-by-work-type" element={<OpportunityByWorkType />} />
              <Route path="sales/opportunity-by-geo-area" element={<OpportunityByGeoArea />} />
              <Route
                path="sales/opportunity-by-quote-number"
                element={<OpportunitiesByQuoteNumber />}
              />
              <Route path="sales/anual-submitted-bids" element={<AnualSubmittedBids />} />
              <Route
                path="sales/opportunity-by-project-number"
                element={<OpportunitiesByProjectNumber />}
              />
              <Route
                path="sales/opportunity-by-start-end-date"
                element={<OpportunityByStartEndDate />}
              />
            </Routes>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Reports
